import { IAppointmentProps } from '@/entities/Appointment'
import { EmptyResponsePropsFactory, IResponseProps } from '@/entities/Response'

export interface IScheduleState {
  response: IResponseProps<IAppointmentProps>
  current: IAppointmentProps | null
  type: string | null
  open: boolean
  scrollTop: number
}

export const state = (): IScheduleState => ({
  response: EmptyResponsePropsFactory(),
  current: null,
  type: null,
  open: false,
  scrollTop: 0
})

export default state
